module.exports = __webpack_public_path__ + "img/SDG-13.d1dddee0.svg";